/** Particle burst: emitter box around the burst point, sizes, lifetimes, speeds, upward drift, RGBA colours. */
export interface DustBurstConfig {
  readonly capacity: number;
  readonly perImpact: number;
  readonly area: { readonly halfWidth: number; readonly height: number; readonly halfDepth: number };
  readonly size: { readonly min: number; readonly max: number; readonly growth: number };
  readonly lifetime: { readonly min: number; readonly max: number };
  readonly speed: { readonly min: number; readonly max: number };
  readonly rise: number;
  readonly color: readonly [number, number, number, number];
  readonly colorFade: readonly [number, number, number, number];
}

/** Tuning of scripted set-piece events (visual timing and feedback only). */
export interface EventsConfig {
  readonly collapse: {
    /** Fall time of one building piece (seconds). */
    readonly pieceFallDuration: number;
    /** Extra tumble rotation mid-air (degrees). */
    readonly tumbleDegrees: number;
    /** Camera rumble when the collapse starts (trauma 0..1). */
    readonly rumbleTrauma: number;
    /** Camera shake per piece impact at close range (trauma 0..1). */
    readonly impactTrauma: number;
    /** Impacts further away than this are not felt (meters). */
    readonly impactShakeRange: number;
    /** Concrete dust cloud rising where a piece lands (SEG_20 sheet: "Staubwolke"). */
    readonly dust: DustBurstConfig;
  };
  /** Terrain feedback (camera trauma 0..1): fall into a pit, head against a ceiling. */
  readonly terrain: {
    readonly fallTrauma: number;
    readonly headBumpTrauma: number;
  };
}

export const EVENTS_CONFIG: EventsConfig = {
  collapse: {
    pieceFallDuration: 1.05,
    tumbleDegrees: 55,
    rumbleTrauma: 0.35,
    impactTrauma: 0.45,
    impactShakeRange: 70,
    dust: {
      capacity: 260,
      perImpact: 40,
      area: { halfWidth: 1.1, height: 0.4, halfDepth: 0.8 },
      size: { min: 0.7, max: 1.6, growth: 2.6 },
      lifetime: { min: 1.2, max: 2.4 },
      speed: { min: 0.6, max: 2.2 },
      rise: 0.35,
      color: [0.62, 0.6, 0.56, 0.7],
      colorFade: [0.7, 0.68, 0.64, 0],
    },
  },
  terrain: {
    fallTrauma: 0.5,
    headBumpTrauma: 0.18,
  },
};
